import React, { useEffect, useState } from "react";
import { useLang } from "../context/LangContext";
import { api } from "../lib/api";
import SimpleMarkdown from "../components/SimpleMarkdown";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  const { t, lang } = useLang();
  const [content, setContent] = useState("");
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/legal")
      .then((r) => setContent(lang === "en" ? r.data.impressum_en || "" : r.data.impressum_de || ""))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [lang]);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="impressum-page">
      <button onClick={() => navigate(-1)} className="flex items-center text-sm text-muted-foreground hover:text-foreground mb-4 transition-colors">
        <ArrowLeft className="w-4 h-4 mr-1" /> {lang === "en" ? "Back" : "Zurück"}
      </button>
      <p className="label-mini">Legal</p>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight leading-none mt-1 mb-6">{t("legal.impressumTitle")}</h1>
      <div className="swiss-card p-6 text-sm space-y-4 text-foreground/90">
        {loaded && content && content.trim() ? (
          <SimpleMarkdown text={content} />
        ) : (
          <>
            <p className="text-muted-foreground italic">{t("legal.placeholder")}</p>
            <div>
              <h3 className="font-semibold mb-1">Anbieter</h3>
              <p>Beta-Webagentur<br />Düsseldorf, Deutschland</p>
            </div>
            <div>
              <h3 className="font-semibold mb-1">Kontakt</h3>
              <p>E-Mail: support@beta-webagentur.de<br />Web: <a href="https://beta-webagentur.de" target="_blank" rel="noreferrer" className="text-[#0055FF] hover:underline">beta-webagentur.de</a></p>
            </div>
            <div>
              <h3 className="font-semibold mb-1">Verantwortlich für den Inhalt</h3>
              <p>Beta-Webagentur, Düsseldorf</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
